import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { 
  CustomersCarouselContainer,  
} from "./customers.styles.js";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";

function SamplePrevArrow({ className, style, onClick }) {
    return (
        <MdArrowBackIos
          className={className}
          style={{
            ...style, 
            display: "block",
            color: "#0096d5", 
            fontSize: "20px",
            margin: "5px",
            background: "transparent",            
          }}
          onClick={onClick}
        />            
    );
}

function SampleNextArrow({ className, style, onClick }) {
    return (
        <MdArrowForwardIos
          className={className}
          style={{
            ...style, 
            display: "block",
            color: "#0096d5", 
            fontSize: "20px",
            margin: "5px",
            background: "transparent",            
          }}
          onClick={onClick}
        />            
    );
}

function CustomersCarousel({ children }) {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,      
    adaptiveHeight: true,
    speed: 1000,    
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <SampleNextArrow/>,
    prevArrow: <SamplePrevArrow/>,   
    slidesToShow: 4,
    slidesToScroll: 1,
    swipe: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
        }
      }
    ],
    customPaging: i => (
      <div id="indicator"
        style={{
          width: "10px",
          height: "10px",
          border: "1px #bdeaff solid" ,
          borderRadius: "100px",
        }}
      />
    )
  };
  return (
    <CustomersCarouselContainer>
      <Slider {...settings}>
        { children }
      </Slider>
    </CustomersCarouselContainer>
  );
}

export default CustomersCarousel;
